
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAddressV2, IAddressV2ControlContext } from '@jump-tech-frontend/domain';
import { getAddressLinesForCountry } from '../address.utils';

@Component({
  selector: 'jump-tech-frontend-address-result',
  template: `
    @if (addressLines.length) {
      <div class="address-result">
        @for (addressLine of addressLines; track addressLine) {
          <div class="address-result__result" [innerHTML]="addressLine"></div>
        }
      </div>
    }
    `,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['address-result.component.scss']
})
export class AddressResultComponent {
  public addressLines: string[] = [];

  @Input() set address(address: IAddressV2) {
    if (address?.line1) {
      this.addressLines = address?.line1 ? getAddressLinesForCountry(this.countryCodes, address) : [];
    }
  }
  @Input() context: IAddressV2ControlContext | string = IAddressV2ControlContext.Desktop;

  @Input() countryCodes: string[];
}
